import { ApolloClient, NormalizedCacheObject } from "@apollo/client";

let apolloClient: ApolloClient<NormalizedCacheObject>;

export const setApolloClient = (
  client: ApolloClient<NormalizedCacheObject>,
) => {
  apolloClient = client;
};

export const getApolloClient = () => {
  if (!apolloClient) {
    throw new Error("Apollo client not initialized");
  }
  return apolloClient;
};
